import { Toaster } from 'react-hot-toast'
import { useCallback, type ReactNode } from 'react'
import { emporionToast } from '../lib/ui/emporionToast'
import { ToastContext, type ExtendedToastType } from './toast-context'

/**
 */
export function ToastProvider({ children }: { children: ReactNode }) {
  const showToast = useCallback((type: ExtendedToastType, title: string, message?: string) => {
    const payload = { title, description: message }
    if (type === 'success') {
      emporionToast.success(payload)
      return
    }
    if (type === 'error') {
      emporionToast.error(payload)
      return
    }
    if (type === 'warning') {
      emporionToast.warning(payload)
      return
    }
    if (type === 'loading') {
      emporionToast.loading(payload)
      return
    }
    emporionToast.info(payload)
  }, [])

  return (
    <ToastContext.Provider value={{ showToast }}>
      {children}
      <Toaster
        position="top-right"
        gutter={8}
        containerStyle={{
          top: 20,
          right: 20,
        }}
      />
    </ToastContext.Provider>
  )
}

export default ToastProvider
